import moment from 'moment';
import {WeekDay} from '../../types';

export const getDaysOfTheWeek = (): {key: WeekDay; label: string}[] => {
  const daysOfWeek = [];

  for (let i = 0; i < 7; i++) {
    const day = moment().day(i);

    const weekDay = day.format('dddd') as string;

    const weekDayKey = day.locale('en').format('dddd').toLowerCase() as WeekDay;
    // @ts-ignore
    daysOfWeek.push({key: weekDayKey, label: weekDay});
  }

  return daysOfWeek;
};
